export default {
  title: 'חלה שגיאה בהפעלת הרכיב',
  try: 'נסה שנית',
  view: 'צפה בפרטי השגיאה',
  modal: {
    title: 'פרטי השגיאה',
  },
};
